<template>
  <el-card class="h-full" :body-style="{ height: '100%' }">
    <div>
      <el-input
        size="small"
        clearable
        placeholder="请输入名称"
        class="!w-280px mr-10px"
        v-model="serachData.keyword"
      />
      <el-select
        v-model="serachData.type"
        placeholder="请选择类型"
        class="!w-280px mr-10px"
        clearable
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-button size="small" type="primary" @click="searchList">搜索</el-button>
      <el-button size="small" type="primary" @click="reset">重置</el-button>
      <el-button size="small" type="primary" @click="newDialog('add')">新增</el-button>
    </div>
    <el-table height="calc(100% - 57px)" class="mt-20px" border stripe :data="filterTable">
      <el-table-column type="index" width="60" label="序号"></el-table-column>
      <el-table-column label="组件名称" prop="name" show-overflow-tooltip></el-table-column>
      <el-table-column label="组件类型" prop="type" :formatter="Typeformater"></el-table-column>
      <el-table-column label="创建时间" prop="creationTime" :formatter="Timeformater">
      </el-table-column>
      <el-table-column width="200" label="操作">
        <template slot-scope="scope">
          <el-button
            @click="toDetail(scope.row, 'read')"
            size="mini"
            >查看</el-button
          >
          <el-button size="mini" @click="editDetail(scope.row,'edit')"
            >编辑</el-button
          >
          <el-button size="mini" @click="deleteDetail(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      class="mini-dialog"
      v-dialogDrag
      append-to-body
      :visible.sync="dialogVisible"
      :title="formTitleDic[formTitile]"
      :before-close="closeDialog"
    >
      <el-form :model="form" :rules="formRules" ref="form" label-width="150px" :disabled="formType">
        <el-form-item label="组件名称" prop="name">
          <el-input v-model="form.name" size="small" clearable />
        </el-form-item>
        <el-form-item label="组件类型" prop="type">
          <el-select v-model="form.type" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" size="small" type="textarea" clearable />
        </el-form-item>
      </el-form>
      <div slot="footer" class="flex justify-center" v-if="!formType">
        <el-button size="small" type="primary" class="iconfont icon-save" @click="save()"
          >保存</el-button
        >
        <el-button size="small" class="iconfont icon-close" @click="closeDialog()">取消</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import { ColumApi } from '@wiz-api/workbench'
import dayjs from 'dayjs'
import { dropdownComponent } from '../../js/config'

const columApi = new ColumApi()

export default {
  name: 'editComponent',
  data() {
    return {
      tableData: [],
      dialogVisible: false,
      form: {
        name: '',
        type: null,
        remark: '',
      },
      formRules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          { max: 20, message: '字符数不能超过20个', trigger: 'blur' },
        ],
        type: [{ required: true, message: '请选择组件类型', trigger: 'blur' }],
        remark: [{ max: 200, message: '字符数不能超过200个', trigger: 'blur' }],
      },
      options: dropdownComponent,
      serachData: {
        keyword: '',
        type: '',
      },
      formType: false,
      formTitile: '',
      formTitleDic: {
        read: '查看',
        edit: '编辑',
        add: '新增'
      },
      filterTable: [],
    }
  },
  created() {
    this.getList()
  },
  methods: {
    Timeformater(row) {
      return dayjs(row.creationTime).format('YYYY-MM-DD HH:mm:ss')
    },
    Typeformater(row) {
      const Type = _.filter(this.options, { value: row.type })
      if (Type.length) {
        return Type[0].label
      }
      return null
    },
    searchList() {
      this.filterTable = this.tableData
      this.filterTable = this.filterTable.filter((v) => {
        if (v.name.includes(this.serachData.keyword)) {
          return true
        }
        return false
      })
      this.filterTable = this.filterTable.filter((v) => {
        if (this.serachData.type === '' || v.type === this.serachData.type) {
          return true
        }
        return false
      })
    },
    reset() {
      this.serachData = this.$options.data().serachData
      this.searchList()
    },
    registered() {},
    newDialog(titleType) {
      this.form = this.$options.data().form
      this.dialogVisible = true
      this.formType = false
      this.formTitile = titleType
    },
    editDetail(row, titleType) {
      this.form = _.clone(row)
      this.formType = false
      this.dialogVisible = true
      this.formTitile = titleType
    },
    async getList() {
      const [err, res] = await columApi.tree(1)
      if (!err && res) {
        this.tableData = res
        this.filterTable = res
      }
    },
    toDetail(row, titleType) {
      this.form = row
      this.formType = true
      this.dialogVisible = true
      this.formTitile = titleType
    },
    async deleteDetail(row) {
      this.$confirm('是否确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const [err, res] = await columApi.callDelete({ id: row.id })
        if (!err) {
          this.getList()
          this.$message.success('删除成功')
        }
      })
    },
    async save() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.form.id) {
            this.edit()
            return
          }
          if (this.repeat()) {
            this.$message.warning('组件名称重复')
            return
          }
          const [err, res] = await columApi.add({
            body: {
              ...this.form,
              columnType: 1,
              parentId: null,
            },
          })
          if (!err) {
            this.$message.success('添加成功')
            this.getList()
            // this.$refs.tableRef && this.$refs.tableRef.clearSelection()
          }
          this.dialogVisible = false
        }
      })
    },
    async edit() {
      if (this.editRepeat()) {
        this.$message.warning('组件名称重复')
        return
      }
      const [err, res] = await columApi.update({
        body: {
          ...this.form,
          columnType: 1,
          parentId: null,
        },
      })
      if (!err) {
        this.$message.success('编辑成功')
        this.getList()
        this.dialogVisible = false
      }
    },
    editRepeat() {
      const filterTable = this.tableData.filter((v) => {
        return v.id !== this.form.id
      })
      const tableName = filterTable.map((v) => {
        return v.name
      })
      if (_.includes(tableName, this.form.name)) {
        return true
      }
      return false
    },
    repeat() {
      const tableName = this.tableData.map((v) => {
        return v.name
      })
      if (_.includes(tableName, this.form.name)) {
        return true
      }
      return false
    },
    closeDialog(done) {
      this.$refs.form.clearValidate()
      if (done) {
        done()
      } else {
        this.dialogVisible = false
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
